export enum AdvertisementTypeEnum {
  LB1 = "lb1",
  LB2 = "lb2",
  LB3 = "lb3",
  IMU1 = "imu1",
  IMU2 = "imu2",
  MIDARTICLESPECIAL = "midarticlespecial",
  CATFISH = "catfish",
  PRESTITIAL = "prestitial",
}

export type AdTargetingType<K = string, T = string | string[]> = {
  key: K;
  value: T;
};

export type AdUnitProps = {
  rootClassName?: string;
  type: AdvertisementTypeEnum;
  slot: string;
  id?: string;
  pubAdTargeting: AdTargetingType[] | AdTargetingType<PageAdTargetValue>[];
  articlePageTarget?: ArticleAdPageTargetingType<string, string>[];
  articleSlotTarget?: ArticleAdSlotTargetingType<string, string>[];
  gsChannels?: string[];
};

export type ArticleAdPageTargetingType<T = string | string[]> = {
  key: string;
  value: T;
};

export type ArticleAdSlotTargetingType<T = string | string[]> = {
  key: string;
  value: T;
};

export type CompanionAdUnitProps = AdUnitProps & {
  adSlotSize: googletag.GeneralSize | undefined;
  pageNumber: string;
};

export type PageAdTargetValue =
  | PageAdTargetingTypeEnum.HOME
  | PageAdTargetingTypeEnum.LISTING
  | PageAdTargetingTypeEnum.ARTICLE
  | PageAdTargetingTypeEnum.TAG;

export enum PageAdTargetingTypeEnum {
  HOME = "home",
  LISTING = "listing",
  ARTICLE = "article",
  TAG = "tag",
}

export type TaboolaPageType =
  "article" | "homepage" | "category" | "photo" | "video";

export interface ITaboola {
  mode?: string;
  container?: string;
  placement?: string;
  target_type?: string;
  url?: string;
  flush?: boolean;
  [key in TaboolaPageType]?: "auto";
}
